<template>
  <a-layout-content>
    <a-spin :spinning="pageLoading">
      <a-row :gutter="8">
        <a-col :xs="24" :lg="20">
          <a-card>
            <div slot="title">
              <span class="d-block">Rekap Monitoring Alokasi Pekerjaan</span>
              <small>{{ header.awal_periode }} s/d {{ header.akhir_periode }}</small>
            </div>
            <a-button size="default" @click="handleExport" slot="extra" icon="printer">{{ !isMobile ? "Export" : ""
            }}</a-button>

            <!--            <a-button-->
            <!--              size="default"-->
            <!--              @click="handleExpirt"-->
            <!--              slot="extra"-->
            <!--              icon="printer"-->
            <!--            >{{!isMobile ? 'Expirt' : '' }}</a-button>-->

            <div class="contentX">
              <a-table :loading="loading.tRekap" :columns="deletedata" :data-source="data" :pagination="false" bordered
                size="small" rowKey="tlc" :scroll="{ x: 1500 }">
                <template slot="title">
                  <h3 class="d-block">Rekap Monitoring Alokasi Pekerjaan</h3>
                  <small>{{ header.awal_periode }} s/d
                    {{ header.akhir_periode }}</small>
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
        <a-col :xs="24" :lg="4">
          <a-collapse activeKey="1" forceRender>
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="margin-remove">Riwayat Prosentase</h4>
              </div>

              <div v-for="item in dataRekapProsentase" :key="item.kode_project">
                <span>{{ item.kode_project }}</span>
                <span style="float: right">{{ item.prosentase }} %</span>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </a-spin>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

const plainOptions = ["Gaji", "Value"];
const defaultCheckedList = [];

export default {
  props: {
    id: String,
  },
  components: {},
  name: "RekapAlokasiManifest",
  beforeCreate() {
    // this.form = this.$form.createForm(this);
  },
  data() {
    const sTotal = [];
    const data = [];

    return {
      basedData: {},
      header: {},

      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      monitoring: false,
      pageLoading: false,
      history: false,
      columnData: [],

      indeterminate: true,
      checkAll: false,
      plainOptions,
      checkedList: defaultCheckedList,
      data,
      // columns1,

      columns1: [
        {
          title: "Gaji",
          dataIndex: "gaji",
          key: "gaji",
          align: "center",
          width: "7%",
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          align: "center",
          width: 100,
        },
        {
          title: "Kode Proyek",
          width: 200,
          children: [],
        },
        {
          title: "Total",
          dataIndex: "total",
          key: "total",
          align: "center",
          width: 100,
        },
      ],
      deletedata: this.columns1, //Used to retain the data to be deleted can be used for data rollback operations
      // deletedata: {}, //Used to retain the data to be deleted can be used for data rollback operations
      lPrefix: "C",
      startIndex: 4,
      sTotal,
      tPrefix: "B",
      tempcolumns: this.columns1,
      clmRiwayat: [
        {
          title: "Gaji",
          dataIndex: "gaji",
          key: "gaji",
          align: "center",
          width: "7%",
        },
      ],
      dataRekapProsentase: {},
      loading: {
        tRekap: true,
      },
    };
  },
  watch: {
    id() {
      if (this.id) {
        this.fetching();
      }
    },
  },
  created() {
    this.fetching();
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
  },

  methods: {
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "rekap_alokasi/rekap_alokasi_pekerjaan",
        params: {
          id_rekap: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response.data) {
            this.columnData = response.data.column;
            this.header = response.data.header[0];

            let lPrefix = this.lPrefix;
            let tPrefix = this.tPrefix;
            let row = 4;
            let total = [];

            response.data.column.forEach((item, idx) => {
              let d = [];
              this.columns1[2].children.push({
                title: item,
                align: "center",
                children: [
                  {
                    title: "%",
                    dataIndex: item + "_percent",
                    key: item + "_percent",
                    align: "center",
                    width: 150,
                  },
                  {
                    title: "Value",
                    dataIndex: item + "_value",
                    key: item + "_value",
                    align: "center",
                    width: "4%",
                    customRender: (text, record, index) => {
                      const obj = {
                        children: text,
                        attrs: {},
                      };

                      obj.attrs["x:num"] = "";
                      if (
                        idx == 0 &&
                        record.tlc.toLowerCase() !== "sub total"
                      ) {
                        obj.attrs["x:fmla"] = "=$A" + row + "*" + lPrefix + row;
                        tPrefix = this.getNextKey(tPrefix);
                        d.push(tPrefix + row);
                        total.push(d);
                      } else if (
                        idx > 0 &&
                        record.tlc.toLowerCase() !== "sub total"
                      ) {
                        lPrefix = this.getNextKey(lPrefix);
                        obj.attrs["x:fmla"] = "=$A" + row + "*" + lPrefix + row;
                        tPrefix = this.getNextKey(tPrefix);
                        d.push(tPrefix + row);
                        total.push(d);
                      } else {
                        obj.attrs["x:fmla"] =
                          "=SUM(" +
                          total[idx][0] +
                          ":" +
                          total[idx][total[idx].length - 1] +
                          ")";
                      }

                      if (idx == this.columnData.length - 1) {
                        lPrefix = this.lPrefix;
                        tPrefix = this.tPrefix;
                        row++;
                      }

                      return obj;
                    },
                  },
                ],
              });
            });

            this.deletedata = this.columns1;
            this.data = response.data.data;
            this.dataRekapProsentase = response.data.rekap_prosentase;
            this.loading.tRekap = false;
            this.onChange(["Value", "Gaji"]);
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.loading.tRekap = false;
        });
    },

    handleExpirt() {
      // console.log(this.getNextKey('ay'))

      console.log("a".charCodeAt());
      console.log("b".charCodeAt());
      console.log("c".charCodeAt());
      console.log("bz".charCodeAt());
      console.log(String.fromCharCode("BY".charCodeAt() + 1));
      console.log(String.fromCharCode("BY".charCodeAt() - 1));
    },
    handleExport(table, name) {
      this.loading.tRekap = true;
      this.onChange([]);
      setTimeout(() => {
        this.fireDownload(table, name);
        this.$router.go();
      }, 3000);
    },
    fireDownload(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>table, td {border:thin solid black}table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      if (!table.nodeType) table = document.getElementsByClassName("contentX");
      let ctx = { worksheet: name || "Worksheet", table: table[0].innerHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "RAP.xls";
      a.click();
    },
    onChange(checkedList) {
      var _that = this;
      if (checkedList.length > 0) {
        //For individually selected functions
        this.indeterminate =
          !!checkedList.length && checkedList.length < plainOptions.length;
        this.checkAll = checkedList.length === plainOptions.length;
        //Just control the data rendering of checkedList
        //Modify the table data

        // console.log(this.columns)
        this.deletedata = JSON.parse(JSON.stringify(this.columns1)); //This treatment prevents the address from being passed
        let deletearray = JSON.parse(JSON.stringify(this.columns1));

        let targetValueList = checkedList.indexOf("Value");
        let targetGaji = checkedList.indexOf("Gaji");

        let valueList = [];

        let listcolumn = [];
        if (targetValueList >= 0) {
          valueList.forEach((item) => {
            listcolumn.push(item);
          });
        }

        if (targetGaji >= 0) {
          listcolumn.push("Gaji");
        }

        checkedList.forEach((item) => {
          if (item == "Gaji") {
            for (let i = 0; i < deletearray.length; i++) {
              if (item == deletearray[i].title || item == deletearray[i]) {
                deletearray.splice(i, 1);
                _that.deletedata = deletearray;
              }
            }
          }
          if (item == "Value") {
            for (let i = 0; i < deletearray.length; i++) {
              if (deletearray[i].title == "Kode Proyek") {
                const child = deletearray[i].children;
                for (let a = 0; a < child.length; a++) {
                  child[a].children.pop();
                  _that.deletedata = deletearray;
                }
              }
            }
          }
        });
      } else {
        _that.deletedata = this.columns1;
      }
    },

    nextLetter(l) {
      if (l < 90) {
        return String.fromCharCode(l + 2);
      } else {
        return "A";
      }
    },
    same(str, char) {
      let i = str.length;
      while (i--) {
        if (str[i] !== char) {
          return false;
        }
      }
      return true;
    },

    nextChar(c) {
      let u = c.toUpperCase();
      if (this.same(u, "Z")) {
        var txt = "";
        var i = u.length;
        while (i--) {
          txt += "A";
        }
        return txt + "B";
      } else {
        var p = "";
        var q = "";
        if (u.length > 1) {
          p = u.substring(0, u.length - 1);
          q = String.fromCharCode(p.slice(-1).charCodeAt(0));
        }
        var l = u.slice(-1).charCodeAt(0);
        var z = this.nextLetter(l);
        if (z === "A") {
          return (
            p.slice(0, -1) + this.nextLetter(q.slice(-1).charCodeAt(0)) + z
          );
        } else {
          return p + z;
        }
      }
    },

    getNextKey(key) {
      if (key === "Z" || key === "z") {
        // return String.fromCharCode(key.charCodeAt() - 25) + String.fromCharCode(key.charCodeAt() - 25); // AA or aa
        return (
          String.fromCharCode(key.charCodeAt() - 25) +
          String.fromCharCode(key.charCodeAt() - (25 - 1))
        ); // AA or aa
      } else if (key === "Y" || key === "y") {
        return (
          String.fromCharCode(key.charCodeAt() - 24) +
          String.fromCharCode(key.charCodeAt() - 24)
        );
      } else if (key === "AY" || key === "ay") {
        return (
          String.fromCharCode(key.charCodeAt() + 1) +
          String.fromCharCode(key.charCodeAt())
        );
      } else if (key === "AZ" || key === "az") {
        return (
          String.fromCharCode(key.charCodeAt() + 1) +
          String.fromCharCode(key.charCodeAt() + 1)
        );
      } else if (key === "BY" || key === "by") {
        return (
          String.fromCharCode(key.charCodeAt() + 1) +
          String.fromCharCode(key.charCodeAt() - 1)
        );
      } else if (key === "BZ" || key === "bz") {
        return (
          String.fromCharCode(key.charCodeAt() + 1) +
          String.fromCharCode(key.charCodeAt())
        );
      } else {
        let lastChar = key.slice(-1);
        let sub = key.slice(0, -1);
        if (lastChar === "Z" || lastChar === "z") {
          // If a string of length > 1 ends in Z/z,
          // increment the string (excluding the last Z/z) recursively,
          // and append A/a (depending on casing) to it
          return (
            this.getNextKey(sub) +
            String.fromCharCode(lastChar.charCodeAt() - 25)
          );
        } else {
          // (take till last char) append with (increment last char)
          return sub + String.fromCharCode(lastChar.charCodeAt() + 2);
        }
      }
      // return key;
    },
  },
  mounted() { },
};
</script>

<style></style>
